// 借入申込内容変更
import React from 'react';
import TopArea from '../../molecules/TopArea';
import Reception from '../../templates/Reception';
import { StepNavigation as StepType } from '../../types/Template';
import { ParentShelf, ChildShelf, Content, GuarantorInfo } from '../../types/Template';
import ChangeRequest from '../../templates/ChangeRequest';
import LoadingModal from '../../molecules/LoadingModal';
import FooterExaminationApplicantInput from '../../organisms/FooterExaminationApplicantInput';

import OnlineIdentificationDialog from '../../molecules/OnlineIdentificationDialog';
interface Props {
  step_navigation: StepType;
  reception_cd: string;
  label: string;
  status_name: string;
  display_reception_cd: boolean;
  guide_text: string;
  looks_inactive: boolean;
  parent_shelfs: ParentShelf[];
  child_shelfs: ChildShelf[];
  contents: Content[];
  setParentShelfs: React.Dispatch<React.SetStateAction<ParentShelf[]>>;
  setChildShelfs: React.Dispatch<React.SetStateAction<ChildShelf[]>>;
  setContents: React.Dispatch<React.SetStateAction<Content[]>>;
  reception_id: number;
  status_code: number;
  opened_mypage: boolean;
  tempSave: () => Promise<any>;
  moveNextStep: () => void;
  change_request_message: string;
  guarantors_num: number;
  show_error_nav: boolean;
  display_status: boolean;
  validate: () => Promise<any>;
  requestModuleAutodisplay: () => void;
  callApi: (function_name: string) => Promise<any>;
  is_staff: boolean;
  is_loading: boolean;
  guarantor_info: GuarantorInfo;
  is_bank_exists: boolean;
  is_desired_bank_exists: boolean;
  is_ja_exists: boolean;
  is_mypage_ja: boolean;
  is_implement_online_identification: boolean;
  setIsImplementOnlineIdentification: React.Dispatch<React.SetStateAction<boolean>>;
  modal_open: boolean;
  setModalnOpen: React.Dispatch<React.SetStateAction<boolean>>;
  is_corporate_user?: boolean;
  is_agricultural_modernization_funds?: boolean;
}

const ExaminationChangeInput: React.FC<Props> = ({
  step_navigation,
  reception_cd,
  label,
  status_name,
  display_reception_cd,
  guide_text,
  looks_inactive,
  parent_shelfs,
  child_shelfs,
  contents,
  setParentShelfs,
  setChildShelfs,
  setContents,
  guarantors_num,
  change_request_message,
  show_error_nav,
  display_status,
  callApi,
  tempSave,
  moveNextStep,
  validate,
  requestModuleAutodisplay,
  is_staff,
  reception_id,
  status_code,
  is_loading,
  guarantor_info,
  is_bank_exists,
  is_desired_bank_exists,
  is_ja_exists,
  is_mypage_ja,
  is_implement_online_identification,
  setIsImplementOnlineIdentification,
  modal_open,
  setModalnOpen,
  is_corporate_user,
  is_agricultural_modernization_funds,
}) => {
  return (
    <>
      <TopArea
        step_navigation={step_navigation}
        reception_cd={reception_cd}
        label={label}
        status_name={status_name}
        display_reception_cd={display_reception_cd}
        guide_text={guide_text}
        display_status={display_status}
      />
      <ChangeRequest change_request_message={change_request_message} />
      <Reception
        looks_inactive={looks_inactive}
        parent_shelfs={parent_shelfs}
        child_shelfs={child_shelfs}
        contents={contents}
        setParentShelfs={setParentShelfs}
        setChildShelfs={setChildShelfs}
        setContents={setContents}
        guarantors_num={guarantors_num}
        show_error_nav={show_error_nav}
        callApi={callApi}
        guarantor_info={guarantor_info}
        is_bank_exists={is_bank_exists}
        is_desired_bank_exists={is_desired_bank_exists}
        is_ja_exists={is_ja_exists}
        is_mypage_ja={is_mypage_ja}
        setIsImplementOnlineIdentification={setIsImplementOnlineIdentification}
        is_corporate_user={is_corporate_user}
        is_agricultural_modernization_funds={is_agricultural_modernization_funds}
      />
      <FooterExaminationApplicantInput
        is_staff={is_staff}
        reception_cd={reception_cd}
        reception_id={reception_id}
        status_code={status_code}
        tempSave={tempSave}
        moveNextStep={moveNextStep}
        validate={validate}
        is_implement_online_identification={is_implement_online_identification}
        requestModuleAutodisplay={requestModuleAutodisplay}
      />
      <OnlineIdentificationDialog
        is_guarantor={false}
        modal_open={modal_open}
        setModalnOpen={setModalnOpen}
      />
      <LoadingModal show={is_loading} />
    </>
  );
};

export default ExaminationChangeInput;
